import { useMemo, useState } from "react";
import type { Account, AccountSubtype } from "@/lib/finance";
import { AccountFormDialog } from "@/components/accounts/AccountFormDialog";

export const NEW_ACCOUNT = "__new_account__";
type Request = { allowed: AccountSubtype[]; done: (a: Account) => void };

/** Crea cuentas desde cualquier selector sin salir del formulario; la nueva queda en la lista y seleccionada. */
export function useInlineAccount(accounts: Account[]) {
  const [extra, setExtra] = useState<Account[]>([]);
  const [req, setReq] = useState<Request | null>(null);
  const all = useMemo(() => [...accounts, ...extra.filter((e) => !accounts.some((a) => a.id === e.id))], [accounts, extra]);
  const create = (allowed: AccountSubtype[], done: (a: Account) => void) => setReq({ allowed, done });
  const dialog = (
    <AccountFormDialog open={!!req} onOpenChange={(o) => { if (!o) setReq(null); }} account={null} onSaved={() => undefined} nested
      allowed={req?.allowed} onCreated={(a) => { setExtra((x) => [...x, a]); req?.done(a); }} />
  );
  return { all, create, dialog };
}
